import { Pipe, PipeTransform } from '@angular/core';
import { NoteTagInfo, LOAN_NOTE_TAG_ORDER } from '../models/note.model';
import { sortByTagOrder } from '../../../utils';

@Pipe({ name: 'sortNoteTags', standalone: true })
export class SortNoteTagsPipe implements PipeTransform {
  transform(tags: NoteTagInfo[]): NoteTagInfo[] {
    return sortByTagOrder(tags, LOAN_NOTE_TAG_ORDER);
  }
}
